"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isXsMobile = isXsMobile;
exports.isMobile = isMobile;
exports.isTablet = isTablet;
exports.isDesktop = isDesktop;
exports.isLargeDesktop = isLargeDesktop;
exports.notMobile = notMobile;
exports.notTablet = notTablet;
exports.notDesktop = notDesktop;
exports.notLargeDesktop = notLargeDesktop;
exports.isHighPixelDensity = isHighPixelDensity;
exports.LG_DESKTOP_MIN = exports.DESKTOP_MAX = exports.DESKTOP_MIN = exports.TABLET_MAX = exports.TABLET_MIN = exports.MOBILE_MAX = exports.XS_MOBILE_MAX = void 0;
var XS_MOBILE_MAX = 480;
exports.XS_MOBILE_MAX = XS_MOBILE_MAX;
var MOBILE_MAX = 767;
exports.MOBILE_MAX = MOBILE_MAX;
var TABLET_MIN = 768;
exports.TABLET_MIN = TABLET_MIN;
var TABLET_MAX = 991;
exports.TABLET_MAX = TABLET_MAX;
var DESKTOP_MIN = 992;
exports.DESKTOP_MIN = DESKTOP_MIN;
var DESKTOP_MAX = 1999;
exports.DESKTOP_MAX = DESKTOP_MAX;
var LG_DESKTOP_MIN = 1200;
exports.LG_DESKTOP_MIN = LG_DESKTOP_MIN;

function isXsMobile() {
  return window.matchMedia("(max-width: ".concat(XS_MOBILE_MAX, "px)")).matches;
}

function isMobile() {
  return window.matchMedia("(max-width: ".concat(MOBILE_MAX, "px)")).matches;
}

function isTablet() {
  return window.matchMedia("(min-width: ".concat(TABLET_MIN, "px) and (max-width: ").concat(TABLET_MAX, "px)")).matches;
}

function isDesktop() {
  return window.matchMedia("(min-width: ".concat(DESKTOP_MIN, "px)")).matches;
}

function isLargeDesktop() {
  return window.matchMedia("(min-width: ".concat(LG_DESKTOP_MIN, "px)")).matches;
}

function notMobile() {
  return window.matchMedia("(min-width: ".concat(TABLET_MIN, "px)")).matches;
}

function notTablet() {
  return window.matchMedia("(max-width: ".concat(MOBILE_MAX, "px), (min-width: ").concat(DESKTOP_MIN, "px)")).matches;
}

function notDesktop() {
  return window.matchMedia("(max-width: ".concat(TABLET_MAX, "px)")).matches;
}

function notLargeDesktop() {
  return window.matchMedia("(max-width: ".concat(DESKTOP_MAX, "px)")).matches;
}

function isHighPixelDensity() {
  return window.matchMedia('(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)').matches;
}